<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="unidad-medida" titulo="Unidad Medida / Catalogos" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>


<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">

            <!-- formulario -->
            <form name="form" novalidate [formGroup]="dato" (ngSubmit)="ctrl.enviar()">
                <section class="hero is-primary">
                    <div class="hero-body">

                        <!-- Opciones  -->
                        <app-formulario-opciones [ctrl]="ctrl" [id]="ctrl.dato.id"></app-formulario-opciones>
                    </div>
                </section>

                <section class="section" style="overflow: auto;padding: 1rem !important;height: 85.8vh;">

                    <a id="catalogos" (click)=" ctrl.cargarCatalogo('catalogos_unidades_medidas', ctrl.CFDI_PATH+'/api/v1/catalogo-unidad-medida');"></a>

                    <div class="field">
                        <label class="label">Seleccione la unidad a agregar del cátalogo del SAT:</label>
                        <ng-select2 [disabled]="ctrl.catalogos_unidades_medidas ? ctrl.catalogos_unidades_medidas.length == 0 ? true : false : true" name="um" [options]="ctrl.optionSelect" (valueChanged)="seleccionarValorSelect2($event, ctrl.catalogos_unidades_medidas);"
                            [data]="ctrl.catalogos_unidades_medidas"></ng-select2>

                    </div>
                    <div class="field">
                        <label class="label">Clave:</label>
                        <p class="control has-icons-left has-icons-right">
                            <input class="input" autofocus type="text" [ngClass]="{'is-danger': ctrl.dato.get('clave').hasError('required') }" placeholder="Clave"
                                formControlName="clave" readonly>
                            <span class="icon is-small is-right" *ngIf="ctrl.dato.get('clave').hasError('required') " >
                                <i class="fa fa-warning"></i>
                            </span>
                            <span class="help is-danger" *ngIf="ctrl.dato.get('clave').hasError('required') ">Este campo es requerido.</span>
                        </p>
                    </div>
                    <div class="field">
                        <label class="label">Nombre:</label>
                        <p class="control has-icons-left has-icons-right">
                            <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.get('nombre').hasError('required') }" placeholder="Nombre"
                                formControlName="nombre" readonly>
                            <span class="icon is-small is-right" *ngIf="ctrl.dato.get('nombre').hasError('required') ">
                                <i class="fa fa-warning"></i>
                            </span>
                            <span class="help is-danger" *ngIf="ctrl.dato.get('nombre').hasError('required') ">Este campo es requerido.</span>
                        </p>
                    </div>

                    <div class="field">
                        <label class="label">Simbolo:</label>
                        <p class="control has-icons-left has-icons-right">
                            <input class="input" type="text" formControlName="simbolo" readonly>

                        </p>
                    </div>


                    <div class="field">
                        <label class="label">Tipo de medida:</label>
                        <div class="b-checkbox is-info is-circular">
                            <input type="radio" id="tipo_medida1" class="styled" name="tipo_medida" value="M1" formControlName="tipo_medida">
                            <label for="tipo_medida1">
                                Lineal
                            </label>

                            <input type="radio" id="tipo_medida2" class="styled" name="tipo_medida" value="M2" formControlName="tipo_medida">
                            <label for="tipo_medida2">
                                Cuadrado
                            </label>

                            <input type="radio" id="tipo_medida3" class="styled" name="tipo_medida" value="M3" formControlName="tipo_medida">
                            <label for="tipo_medida3">
                                Cúbico
                            </label>
                        </div>

                    </div>

                </section>
            </form>
        </div>
    </div>
</div>
